import { useTranslation } from "react-i18next";
import { useRouter } from "next/router";
import {useMemo, useState} from "react";

export const getCurrentLanguage = () => {
  const browserLang = navigator.language;
  const lang = localStorage.getItem('language');
  if (lang) {
    return langList.find((item) => lang === item.code).name;
  }
  return langList.find((item) => browserLang.toLowerCase().startsWith(item.code))?.name ?? "US";
};

const langList = [
  { code: 'en', name: 'US', icon: "/images/region/usa-icon.png" },
  { code: 'fr', name: 'France', icon: "/images/region/france-icon.png" },
];


const useLanguage = () => {
  const { t, i18n } = useTranslation();
  const router = useRouter();

  const isFr = useMemo(() => {
    return i18n.language === 'fr';
  }, [i18n.language]);

  const isUS = useMemo(() => {
    return i18n.language === 'en';
  }, [i18n.language]);

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem('language', lang);
    router.reload();
  };

  const changeLanguageWithoutReload = (lang) => {
    if (langList.map(item => item.code).includes(lang)){
      i18n.changeLanguage(lang);
      localStorage.setItem('language', lang);
    }
  };

  const initLanguage = () => {
    const lang = localStorage.getItem('language');
    if (lang) {
      i18n.changeLanguage(lang);
      return;
    }
    const browserLang = navigator.language;
    if (browserLang.startsWith('zh')) {
      i18n.changeLanguage('en');
    } else if (browserLang.startsWith('en')) {
      i18n.changeLanguage('en');
    } else if (browserLang.startsWith('fr')) {
      i18n.changeLanguage('fr');
    } else if (browserLang.startsWith('kr')) {
      i18n.changeLanguage('kr');
    } else if (browserLang.startsWith('jp')) {
      i18n.changeLanguage('jp');
    }
  };

  const unit = useMemo(() =>{
    if (isUS) return "$";
    if (isFr) return "€";
    return "$";
  }, [i18n.language]);


  const capBanner = useMemo(() =>{
    if (isFr) return {
      capOK:"/images/profile/un-lock-icon-fr.png",
      capLock: "/images/profile/lock-icon-fr.png"
    };
    return {
      capOK:"/images/profile/profile-cap-ok.png",
      capLock: "/images/profile/profile-top-right-bg.png"
    };
  }, [isFr]);

  const showcaseBanner = useMemo(() =>{
    if (isFr) return "/images/profile/use_des_icon_fr.png";
    return "/images/use_des_icon.png";
  }, [isFr]);

  const freeSampleIcon = useMemo(()=>{
    if (isFr) return "/images/profile/fr-free-sample.png";
    return "/images/product/free-sample-icon.png";
  }, [isFr]);

  return {
    t,
    changeLanguage,
    changeLanguageWithoutReload,
    initLanguage,
    currentLang: langList.find(item => item.code === i18n.language),
    langList,
    isFr,
    isUS,
    unit,
    capBanner,
    showcaseBanner,
    freeSampleIcon
  };
};


export default useLanguage;
